import React from 'react';
import CheckCircleOutlined from '../../Icons/CheckCircleOutlined';
import ErrorOutline from '../../Icons/ErrorOutline';
import InfoOutlined from '../../Icons/InfoOutlined';
import WarningAmberOutlined from '../../Icons/WarningAmberOutlined';
export default function Alert(theme) {
    const standardStyle = (color)=>({
            color: theme.palette[color].shades['160p'],
            backgroundColor: theme.palette[color].shades['190p'],
            '& .MuiAlert-icon': {
                color: theme.palette[color].main
            }
        });
    const outlinedStyle = (color)=>({
            color: theme.palette[color].shades['160p'],
            border: `solid 1px ${theme.palette[color].main}`,
            backgroundColor: 'inherit',
            '& .MuiAlert-icon': {
                color: theme.palette[color].main
            }
        });
    const filledStyle = (color)=>({
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main
        });
    return {
        MuiAlert: {
            defaultProps: {
                iconMapping: {
                    success: /*#__PURE__*/ React.createElement(CheckCircleOutlined, null),
                    error: /*#__PURE__*/ React.createElement(ErrorOutline, null),
                    warning: /*#__PURE__*/ React.createElement(WarningAmberOutlined, null),
                    info: /*#__PURE__*/ React.createElement(InfoOutlined, null)
                }
            },
            styleOverrides: {
                root: {
                    borderRadius: theme.radius.small
                },
                message: {
                    fontWeight: theme.typography.fontWeightRegular,
                    overflow: 'visible',
                    '& .MuiAlertTitle-root': {
                        marginBottom: theme.spacing(0.5),
                        fontWeight: theme.typography.fontWeightMedium
                    }
                },
                action: {
                    '& button:not(:first-of-type)': {
                        marginLeft: theme.spacing(1)
                    }
                },
                icon: {
                    padding: '6px 0'
                },
                standardInfo: standardStyle('info'),
                standardSuccess: standardStyle('success'),
                standardWarning: standardStyle('warning'),
                standardError: standardStyle('error'),
                filledInfo: filledStyle('info'),
                filledSuccess: filledStyle('success'),
                filledWarning: filledStyle('warning'),
                filledError: filledStyle('error'),
                outlinedInfo: outlinedStyle('info'),
                outlinedSuccess: outlinedStyle('success'),
                outlinedWarning: outlinedStyle('warning'),
                outlinedError: outlinedStyle('error')
            }
        }
    };
}
